document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("click", (e) => {
    const trigger = e.target.closest("modal-trigger");
    if (!trigger) return;

    const targetId = trigger.getAttribute("target")?.replace("#", "");
    const method = trigger.getAttribute("action");

    const modal = document.getElementById(targetId);
    if (!modal) return;

    const navArrows = modal.querySelector("#modalNavArrows");
    if (!navArrows) return;

    const index = parseInt(navArrows.getAttribute("data-id"), 10);
    const maxIndex = parseInt(navArrows.getAttribute("data-max"), 10);
    const [prev, next] = navArrows.querySelectorAll("button");

    if (prev) prev.disabled = index === 1;
    if (next) next.disabled = index === maxIndex;

    function handleClick(newIndex) {
      return () => {
        const newTrigger = document.querySelector(
          `modal-trigger[target="#modal-video-${newIndex}"]`,
        );
        const closeEvent = new CustomEvent(`modal.${targetId}`, {
          detail: { action: "close" },
        });

        window.dispatchEvent(closeEvent);

        newTrigger.click();
      };
    }

    if (prev && index > 1) {
      prev.addEventListener("click", handleClick(index - 1), { once: true });
    }

    if (next && index < maxIndex) {
      next.addEventListener("click", handleClick(index + 1), { once: true });
    }

    const video = modal.querySelector("video");
    const source = video?.querySelector("source");
    const videoSrc = video?.getAttribute("data-src");

    if (method === "open") {
      if (video && source && videoSrc) {
        source.setAttribute("src", videoSrc);
        video.load();
        video.play();
      }
    }

    const handleModalClose = (e) => {
      if (e.detail.action !== "close") return;
      if (video) video.pause();
    };

    window.addEventListener(`modal.${targetId}`, handleModalClose, {
      once: true,
    });
  });
});
